import { Component } from '@angular/core';

@Component({
  selector: 'mtm-export-icon',
  templateUrl: './export-icon.component.html',
  styles: [],
  standalone: false,
})
export class ExportIconComponent {}
